<template>
  <div class="message-box" :class="[cssClasses, colorClass]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'green'
    }
  },
  computed: {
    colorClass() {
      return `message-box--${this.color}`
    }
  }
}
</script>

<style lang="scss">
.message-box {
  @include body-smaller;
  padding: measure(half);

  @include media(small) {
    @include body;
  }
}

.message-box--green {
  background-color: color(background-light-green);
  border: 1px solid color(border-success-green);
}

.message-box--orange {
  background-color: color(background-yellow);
  border: 1px solid color(border-yellow);
}

.message-box--red {
  background-color: color(background-yellow);
  border: 1px solid #ff0000;
  color: #ff0000;
  margin-bottom: 10px;
}

.message-box--white {
  background-color: color(background-white);
  border: 1px solid color(border-gray);
}

.message-box--compact {
  @include body-smaller-semi-bold;
  display: inline-flex;
  align-items: center;
  padding: measure(quarter) !important;
}

.message-box--compact > svg {
  margin-right: measure(quarter);
}

.message-box--compact > button {
  margin-left: measure(quarter);
}

.message-box__box-text {
  @include body-smaller-semi-bold;

  @include media(small) {
    @include body-semi-bold;
  }
}
</style>
